module.exports = __webpack_public_path__ + "fonts/NormaticaDisplay-Demo.ce469002.eot";